module.exports = __webpack_public_path__ + "media/images/menu/coma_berenices-8a35ddb2b46059ed5a35c031a2d16de6.jpg";